var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17006_91078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2V6H5",
    stroke: "#E02828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14V10H11",
    stroke: "#E02828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.28547C13.6617 4.2614 13.0868 3.34582 12.3288 2.62416C11.5709 1.9025 10.6546 1.39828 9.66559 1.15855C8.67653 0.918819 7.64691 0.951395 6.67278 1.25323C5.69866 1.55507 4.81179 2.11634 4.09492 2.88466L1 6",
    stroke: "#E02828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10L11.9051 13.1153C11.1882 13.8837 10.3013 14.4449 9.32722 14.7468C8.35309 15.0486 7.32347 15.0812 6.33441 14.8415C5.34536 14.6017 4.42911 14.0975 3.67117 13.3758C2.91322 12.6542 2.33829 11.7386 2 10.7145",
    stroke: "#E02828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17006_91078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshRed);
export default __webpack_public_path__ + "static/media/refresh-red.851748f03d9340a7b7f9a448901c08b8.svg";
export { ForwardRef as ReactComponent };